import io from 'socket.io-client';

let socket = null;

// Show notification via service worker (works in foreground too)
const showNotification = async (data) => {
  if (!('serviceWorker' in navigator) || Notification.permission !== 'granted') return;
  try {
    const registration = await navigator.serviceWorker.ready;
    const title = data.title || 'Bigwals';
    const options = {
      body: data.body,
      icon: data.icon || '/icons/icon-192x192.png',
      badge: data.badge || '/icons/icon-72x72.png',
      tag: `msg-${data.data?.channelId || Date.now()}`,
      data: { url: data.data?.url || '/dashboard', ...data.data },
      vibrate: [200, 100, 200]
    };
    registration.showNotification(title, options);
  } catch (e) {
    console.error('[NOTIF] Failed to show notification:', e);
  }
};

export const initSocket = (token) => {
  if (socket) {
    socket.disconnect();
  }

  socket = io(process.env.REACT_APP_SOCKET_URL || 'https://management.bigwalstudio.com', {
    auth: {
      token
    },
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionAttempts: 5
  });

  socket.on('connect', () => {
    console.log('Socket connected');
  });

  socket.on('disconnect', () => {
    console.log('Socket disconnected');
  });

  socket.on('connect_error', (error) => {
    console.error('Socket connection error:', error);
  });

  // Show foreground push notifications
  socket.on('notification:new', (data) => {
    showNotification(data);
  });

  return socket;
};

export const getSocket = () => {
  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};

const socketService = {
  initSocket,
  getSocket,
  disconnectSocket
};

export default socketService;
